import { forwardRef } from 'react';
import { cx } from 'class-variance-authority';
import * as ScrollArea from '@radix-ui/react-scroll-area';

import { Box } from '../Box';
import { BaseTypeMap, Component, ComponentProps } from '../types/Component';

type TableRootTypeMap = BaseTypeMap<
  'table',
  { scroll?: 'horizontal' | 'vertical' | 'both' }
>;

export type TableRootProps = ComponentProps<TableRootTypeMap>;

export const TableRoot: Component<TableRootTypeMap> = forwardRef(
  function TableRoot({ children, className, scroll, ...rest }, ref) {
    const root = (
      <Box className="h-full w-full" ref={ref} {...rest} as="table">
        {children}
      </Box>
    );

    if (!scroll) {
      return root;
    }

    return (
      <ScrollArea.Root>
        <ScrollArea.Viewport
          className={cx(
            scroll === 'horizontal' ? 'w-full' : undefined,
            scroll === 'vertical' ? 'h-full' : undefined,
            scroll === 'both' ? 'h-full w-full' : undefined,
            className
          )}
        >
          {root}
        </ScrollArea.Viewport>
        {scroll === 'horizontal' || scroll === 'both' ? (
          <ScrollArea.Scrollbar orientation="horizontal">
            <ScrollArea.Thumb />
          </ScrollArea.Scrollbar>
        ) : null}
        {scroll === 'vertical' || scroll === 'both' ? (
          <ScrollArea.Scrollbar orientation="vertical">
            <ScrollArea.Thumb />
          </ScrollArea.Scrollbar>
        ) : null}
      </ScrollArea.Root>
    );
  }
);
